import type { ExternalLink } from '../data/types';

export function ExternalLinkButton({ link }: { link: ExternalLink }) {
  return (
    <a
      href={link.url}
      target="_blank"
      rel="noopener noreferrer"
      className="bg-primary-600 hover:bg-primary-700 dark:bg-primary-700 dark:hover:bg-primary-600 mt-3 inline-block rounded-lg px-4 py-2 text-sm font-medium text-white transition-colors"
    >
      {link.label} →
    </a>
  );
}
